import { useSignal } from "@preact/signals";
import { FC, Fragment } from "preact/compat";
import { getChats } from "~/core/store";
import InboxIcon from "@material-design-icons/svg/outlined/inbox.svg";
import ChevronLeftIcon from "@material-design-icons/svg/outlined/chevron_left.svg";
import ExpandMoreIcon from "@material-design-icons/svg/outlined/expand_more.svg";
import ChatList from "./ChatList";
import { Transition } from "@headlessui/react";
import ChatContent from "./ChatContent";
import cn from "classnames";

const Content: FC = () => {
    const { chats, popupMinimised } = getChats();
    const selectedChatId = useSignal("");
    const isChatSelected = useSignal(false);
    const selectedChat = chats.value.find(
        (chat) => chat.id === selectedChatId.value
    );

    return (
        <section className="relative flex flex-col w-full h-full overflow-hidden text-sm">
            <div className="px-4 py-2 font-bold flex justify-between border-b border-gray-300 h-[40px]">
                {!isChatSelected.value && (
                    <div className="flex items-center">
                        <InboxIcon
                            className="mr-2 fill-current"
                            width="18"
                            height="18"
                        />
                        <span>Your messages</span>
                    </div>
                )}
                {isChatSelected.value && (
                    <div className="flex items-center">
                        <button
                            title="Back to all chats"
                            type="button"
                            className="flex mr-2 rounded-full hover:bg-gray-100 hover:text-sky-500"
                            onClick={() => (isChatSelected.value = false)}
                        >
                            <ChevronLeftIcon
                                className="fill-current"
                                width="18"
                                height="18"
                            />
                        </button>
                        <span>{selectedChat?.name}</span>
                    </div>
                )}
                <button
                    type="button"
                    title={popupMinimised.value ? "Open chats" : "Hide chats"}
                    onClick={() =>
                        (popupMinimised.value = !popupMinimised.value)
                    }
                    className="p-1 rounded-full hover:bg-gray-100 hover:text-sky-500"
                >
                    <ExpandMoreIcon
                        width="18"
                        height="18"
                        className={cn(
                            "fill-current transition duration-300",
                            popupMinimised.value && "transform rotate-180"
                        )}
                    />
                </button>
            </div>
            <Transition
                show={!isChatSelected.value}
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom="-translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="-translate-x-full"
            >
                <div className="absolute top-[40px] left-0 w-full">
                    <ChatList
                        onSelect={(chat) => {
                            selectedChatId.value = chat;
                            isChatSelected.value = true;
                        }}
                    />
                </div>
            </Transition>
            <Transition
                show={isChatSelected.value}
                as={Fragment}
                enter="transform transition ease-in-out duration-300"
                enterFrom="translate-x-full"
                enterTo="translate-x-0"
                leave="transform transition ease-in-out duration-300"
                leaveFrom="translate-x-0"
                leaveTo="translate-x-full"
            >
                <div className="absolute top-[40px] left-0 w-full h-full">
                    {selectedChat && <ChatContent chat={selectedChat} />}
                </div>
            </Transition>
        </section>
    );
};

export default Content;
